module.exports = "pegasus/assets/blocks/image-3-theme3.png";